import SlideShow from "../Reusable Elements/SlideShow";
import { luxuryImages } from "../../data/slideShowData";
import Button from "../Reusable Elements/Button";

const Luxury = () => {
    return (
        <div className="flex w-screen items-center justify-between sm:flex-row pt-7 sm:pb-7 flex-col-reverse">
            <div>
                <SlideShow side={"left"} images={luxuryImages} />
            </div>
            <div className="flex flex-col sm:pl-10 sm:pr-14 sm:w-[60vw] px-2 items-center gap-y-12 mb-10 sm:mb-0 pt-10 sm:pt-0">
                <div className="w-fit flex items-center flex-col">
                    <div className="font-poppins font-extralight text-5xl text-center text-primary-blue">
                        Luxury Town Homes
                    </div>
                    <div className="font-poppins text-xl font-extralight text-center mt-10 sm:px-6 px-8">
                        At Pearl Residencia, we design high-luxury{" "}
                        <span className="font-normal text-primary-gold">
                            4 Marla{" "}
                        </span>{" "}
                        and
                        <span className="font-normal text-primary-gold">
                            {" "}
                            5 Marla
                        </span>{" "}
                        residences that reflect your unique style.
                    </div>
                    <div className="font-poppins text-xl font-extralight text-center mt-10 sm:px-6 px-8 mb-10">
                        Our dream homes feature premium finishes with marble and
                        granite, along with bespoke fittings and lighting
                        features for unmatched comfort and elegance.
                    </div>
                    <Button text = {'Contact Us'} color={'#ffffff'} location={'/contact'}/>
                </div>
            </div>
        </div>
    );
};

export default Luxury;
